<section class="mtb-30 mt-80 jobView-sec">
    <div class="job-details-header">
      <div class="container">
        <div class="row dsply-flx-cntr">
          <div class="col-md-10">
            <div class="row">
              <div class="listing-header jobVwHeading mrgn-tp-btm">
                <h2 class="defThmSubHeading align-titleJob ">{{jobTitle}}</h2>
                <span class="job-code">#{{jobCode}}</span>
                <div>
                  <h2 class="theme-posted defThmSubHeading ng-binding">Posted {{postedDate}}</h2>
                  <div class="line-left clearfix">|</div>
                  <div class="share-job-box defThmSubHeading customShareJobPadding">
                    <div class="share-job-header align-header-jobShr ng-binding" id="heading1_jobview_jobheading_style2" ng-style="heading1_jobview_jobheading_style">
                      <i class="fa fa-share-alt" aria-hidden="true"></i> Share Job&nbsp;
                    </div>
                    <div style="float: left;">
                      <div class="social-share" style="float: left;">
                        <a href="javascript:void(0)" class="custom-thm8-outline" (click)="genericSocialShare('fb')">
                          <span class="hide"></span>
                          <i class="fa-brands fa-facebook-f"></i>
                        </a>
                        <a href="javascript:void(0)" class="custom-thm8-outline" (click)="genericSocialShare('twitter')">
                          <span class="hide"></span>
                          <i class="fa-brands fa-twitter"></i>
                        </a>
                        <a href="javascript:void(0)" class="custom-thm8-outline" (click)="genericSocialShare('linkedin')">
                          <span class="hide"></span>
                          <i class="fa-brands fa-linkedin-in"></i>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-2 pd-lft-0 mrgn-tp-btm">
            <div class="job-apply-btn">
              <button mat-raised-button color="primary" (click)="onApplyClick()">Apply</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="job-details">
        <lib-job-view (jobViewLoad)="onJobViewLoad($event)"></lib-job-view>
      </div>
      <div class="row details-footer" #target>
        <div class="col-md-12">
          <button mat-raised-button color="primary" (click)="onApplyClick()">Apply</button>
          <button mat-raised-button color="primary" (click)="onBackClick()">Back</button>
        </div>
      </div>
      <div class="container">
        <div *ngIf="loadApplyForm" class="apply-form">
          <div class="row">
            <div class="col-md-8">
              <lib-job-apply class="scrollable-div" (applyTrigger)="loaderLoad = true" [isTncRequired]="false" (jobSuggestions)="getJobSuggestions($event)" (applyResponse)="onJobSubmission($event)" (applyDataLoaded)="scrollToApply($event)"></lib-job-apply>
            </div>
            <div *ngIf="jobSuggestions.length > 0" class="col-md-4 jb-rec-jbview pd-22rem">
              <p class="job-rec-p text-center"> Based on your profile, you may want to check the below open positions before submitting </p>
              <lib-job-recommendation themeName="zm-custom-theme" [jobs]="jobSuggestions" (jobURL)="setJobURL($event)"></lib-job-recommendation>
            </div>
          </div>
        </div>
      </div>
    </div>
</section>
<div [appLoading]="loaderLoad" class="loader-tranporent"></div>